import * as React from "react"
import { AddTraining } from "./Admin/AddTraining"
import { TrainingList } from "./Admin/TrainingList"
import { UserList } from "./Admin/UserList"

//This component manage the Admin part of the app. It show the different Component listed in Admin folder
export const Administration: React.FunctionComponent = (props) => {

    const [adminDisplay, setAdminDisplay] = React.useState('')

    const handleAddTraining = () => {
        setAdminDisplay('AddTraining')
    }
    const handleTrainingList =() => {
        setAdminDisplay('TrainingList')
    }
    const handleUserList = () => {
        setAdminDisplay('UserList')
    }

    const displayAdminPage = () => {
        if(adminDisplay === "AddTraining") {
            return(
                <AddTraining />
            )
        }
        else if (adminDisplay === "TrainingList") {
            return (
                <TrainingList />
            )
        }
        else if (adminDisplay === "UserList") {
            return (
                <UserList />
            )
        }
        else {
            return(
                <div></div>
            )
        }
    }

    return(
        <div>
            <div className="AdminMenu">
                <div className="ConnectButton AdminButton" onClick={handleAddTraining}>Ajouter une Formation</div>
                <div className="ConnectButton AdminButton" onClick={handleTrainingList}>Liste des Formations</div>
                <div className="ConnectButton AdminButton" onClick={handleUserList}>Liste des Utilisateurs</div>
            </div>
            {displayAdminPage()}
        </div>
    )
}